import { LegalLayout } from "@/components/LegalLayout";

const Refunds = () => (
  <LegalLayout
    title="Refund & Dispute Policy"
    description="When and how Cash Isle reverses transactions and resolves disputes."
    updated="May 13, 2026"
  >
    <h2>Person-to-person sends</h2>
    <p>
      Sends between users are <strong>final</strong> once received. We do not
      reverse them at request. If you sent to the wrong cashtag, contact the
      receiver to request a return.
    </p>

    <h2>Money requests</h2>
    <p>
      You can cancel a pending request at any time before it is paid. Once paid,
      the standard person-to-person rule above applies.
    </p>

    <h2>Gig escrow</h2>
    <p>
      Funds posted to a gig are held in escrow until the gig is approved,
      auto-approved after the dispute window, or resolved by an admin. Possible
      outcomes:
    </p>
    <ul>
      <li><strong>Release:</strong> full budget paid to the worker.</li>
      <li><strong>Refund:</strong> full budget returned to the poster.</li>
      <li><strong>Split:</strong> partial release to the worker, remainder refunded to the poster.</li>
    </ul>

    <h2>Merchant payments</h2>
    <p>
      Refunds for merchant purchases are at the merchant's discretion. Contact
      the merchant directly. We will assist if a merchant fails to honour their
      stated policy or if fraud is suspected.
    </p>

    <h2>Withdrawals</h2>
    <p>
      Withdrawals are reviewed before payout. A pending withdrawal can be
      cancelled in-app and the funds returned to your wallet. Once paid out, the
      bank's reversal rules apply.
    </p>

    <h2>Fraud reversals</h2>
    <p>
      We may reverse transactions where we have reasonable grounds to suspect
      fraud, account takeover, or sanctions violation, with or without notice.
    </p>

    <h2>How to open a dispute</h2>
    <ol>
      <li>Open the gig, request, or transaction in-app.</li>
      <li>Tap <em>Open dispute</em> and describe what happened.</li>
      <li>Attach evidence (photos, screenshots, timestamps).</li>
      <li>Our team reviews within 3 business days.</li>
    </ol>

    <h2>Appeals</h2>
    <p>
      If you disagree with a resolution, reply to the resolution email within 7
      days with new evidence. A senior reviewer will look again.
    </p>
  </LegalLayout>
);

export default Refunds;
